export const privacy = {
  "header": {
    "badge": "Personal data",
    "title": "Privacy Policy"
  },
  "content": {
    "intro": "The protection of your privacy and personal data is an absolute priority for DONKEY TRAVEL. This policy details how we collect, process and secure your information.",
    "collection": {
      "title": "1. Data collection",
      "text": "We only collect the data strictly necessary for the proper functioning of the platform: your account creation information (last name, first name, email), links to your public announcements (Airbnb), and your travel preferences and availability. Passwords are encrypted and payment data is processed by our secure partner Stripe."
    },
    "usage": {
      "title": "2. Use of your data",
      "text": "Your information is used to: \n- Check your eligibility (rating 4.5+) \n- Manage your subscription \n- Facilitate connection with other members \n- Provide personalized recommendations via our Intelligent Matching \n- Improve our services and resolve technical problems."
    },
    "sharing": {
      "title": "3. Information sharing",
      "text": "We will NEVER sell your personal data to third parties. Their sharing is strictly limited to operational purposes with our trusted service providers (web hosting, payment tool). Outside of this framework, your data is only shared between members for the organization of an exchange (and only the exact address after validation of an exchange)."
    },
    "security": {
      "title": "4. Security",
      "text": "The most robust authentication and security protocols are in place to protect your data against unauthorized access, alteration, disclosure or destruction."
    },
    "rights": {
      "title": "5. Your rights (GDPR)",
      "text": "In accordance with the General Data Protection Regulations, you have the right to access, rectify, portability or delete your personal data at any time. You can exercise this right from your account settings or by writing to us at dpo@donkey.travel."
    },
    "cookies": {
      "title": "6. Cookies",
      "text": "We use essential cookies to maintain your login session, as well as anonymous analytical cookies to understand how our site is used and improve your experience."
    }
  }
};
